export default __webpack_public_path__ + "static/media/544.74d1294b.jpg";